import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  data: [],
  isFetching: false,
  lockedFilter: false,
};

export default function reportsData(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.REPORTS_REQUEST_DATA:
      return Object.assign({}, state, {
        isFetching: true,
      });

    case ActionTypes.REPORTS_RECEIVE_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data,
      });

    default:
      return state;
  }
}
